import axios, { type AxiosInstance } from "axios";
import { handleSessionExpiredResponse } from "./sessionExpiry.js";
import { apiBaseUrl, getApiAuthorizationHeaderValue } from "./shared.js";

const instance = axios.create({
  baseURL: apiBaseUrl,
  // Avoid sending tokens to other origins.
  // https://github.com/advisories/GHSA-jr5f-v2jv-69x6
  allowAbsoluteUrls: false,
  headers: {
    "Content-Type": "application/json",
  },
});

// Sends an expired session back through sign-in, from any request. The error
// still rejects the request.
instance.interceptors.response.use(undefined, async (error: unknown) => {
  if (axios.isAxiosError(error)) {
    handleSessionExpiredResponse(error.response?.status, error.response?.data);
  }
  throw error;
});

/*
 * Example usage in an async function:
 *   const axios = await getAxiosInstanceWithAuth();
 *   const response = axios.post("/company", { name: companyName });
 */
export async function getAxiosInstanceWithAuth(): Promise<AxiosInstance> {
  const authorization = await getApiAuthorizationHeaderValue();
  instance.defaults.headers["Authorization"] = authorization;
  instance.defaults.headers["x-alpharun-commit-sha"] = __COMMIT_SHA__;
  return instance;
}
